import {
  useCopilotAction,
  useCopilotAdditionalInstructions,
} from "@copilotkit/react-core";
import { useRouter } from "next/router";
import { get } from "lodash";
import { usePathname } from "next/navigation";
import { trackEvent } from "../../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../../utils/mixpanelEvents";
import { useStoreState } from "pullstate";
import Store from "../../../../utils/Store";

const useMenubarActionsWithAI = (onBack, isDisabled) => {
  const pathname = usePathname();
  // Check if the route starts with "/viewer"
  const isViewerRoute = pathname?.startsWith("/viewer");

  useCopilotAction({
    name: "goToWorklist",
    description: "this is to be called whenever the user wants to go back to worklist",
    available: !isDisabled && isViewerRoute ? "enabled" : "disabled",
    handler: async () => {
      trackEvent(MIXPANEL_EVENTS.ASSISTANT_ACTION, {
        action: "goToWorklist",
        from_route: pathname,
      });
      onBack();
    },
  });
};

const useMenubarActions = (onBack) => {
  const { userInfo } = useStoreState(Store, (s) => ({
    userInfo: s.userInfo,
  }));
  const isAIAssistantEnabled = get(
    userInfo,
    ["settings", "ui_settings", "ai_assistant"],
    false
  );
  let isDisabled = !isAIAssistantEnabled || !userInfo;

  return useMenubarActionsWithAI(onBack, userInfo, isDisabled);
};

export default useMenubarActions;
